import { brand } from 'config';

const isBcom = brand === 'bcom';
export default isBcom;
